import { useSelector } from "@xstate/store-react";
import { useMemo, useState } from "react";
import { type BookingFlow, createBookingStore } from "./booking-store";

export function useBookingDialog(initialFlow?: BookingFlow) {
  const [store] = useState(() => createBookingStore(initialFlow));

  const flow = useSelector(store, (s) => s.context.flow);
  const page = useSelector(store, (s) => s.context.page);

  const actions = useMemo(
    () => ({
      setMode: (flow: BookingFlow) => store.send({ type: "booking.setMode", flow }),
      next: () => store.send({ type: "booking.next" }),
      back: () => store.send({ type: "booking.back" }),
      reset: () => store.send({ type: "booking.reset" }),
    }),
    [store],
  );

  const canGoBack = page !== "mode-select";
  const isLastPage = page === "protocols.slots";

  return { flow, page, canGoBack, isLastPage, actions };
}

export type BookingDialogActions = ReturnType<typeof useBookingDialog>["actions"];
